import { Link, NavLink } from 'react-router-dom'
import React, { useState, useEffect, useContext } from 'react'
import Logo from '../image/logo.png'
import { useMediaQuery } from 'react-responsive'
import { AuthContext } from './AuthContext'
import BarLoader from 'react-spinners/BarLoader'

import { Nav, Navbar, Container, Offcanvas } from 'react-bootstrap'
import axios from 'axios'
import Cookies from 'js-cookie'

const MyNav = () => {
  const { currentUser, setCurrentUser, BaseUrl, isLevel2, isLoading } =
    useContext(AuthContext)

  const [show, setShow] = useState(false)

  // BarLoader
  window.addEventListener('resize', updateSize)

  const actualInnerWidth = document.getElementById('mynav')
    ? document.getElementById('mynav').offsetWidth
    : document.body.clientWidth
  const [loadingBarLength, setLoadingBarLength] = useState(actualInnerWidth)
  function updateSize() {
    setLoadingBarLength(actualInnerWidth)
  }

  const offcanvasClose = () => setShow(false)
  const offcanvasShow = () => setShow(true)

  let [lastPos, setLastPos] = useState(0)
  let [currentPos, setCurrentPos] = useState(0)
  // let currentPos = document.documentElement.scrollTop
  const [navTop, setNavTop] = useState('0px')
  const isMobile = useMediaQuery({ query: '(max-width: 576px)' })

  // const navigate = useNavigate()
  const logout = 'member/v1/Logout'

  const handleLogout = () => {
    axios
      .get(BaseUrl + logout, {
        headers: {
          tk: currentUser.tk,
        },
      })
      .then((res) => {
        console.log('logout', res)
      })
      .catch((e) => {
        console.log(e)
      })
  }
  function onScroll() {
    if (currentPos > lastPos && currentPos > 60) {
      setNavTop('-60px')
    } else {
      setNavTop('0px')
    }

    setCurrentPos(document.documentElement.scrollTop)
    setLastPos(currentPos)
  }
  // 手機板 nav 下滑藏起來
  useEffect(() => {
    if (isMobile) {
      document.addEventListener('scroll', onScroll)
      return () => window.removeEventListener('scroll', onScroll)
    }
  }, [currentPos])
  return (
    <>
      <div style={{ top: navTop }} className="myNav sticky-top">
        {/* <BarLoader
          cssOverride={{
            overflow: 'hidden',
            position: 'fixed ',
            zIndex: '1021',
          }}
          color="#df0080"
          width={loadingBarLength}
          loading={isLoading}
        /> */}
        <Navbar
          key="xl"
          expand="xl"
          id="mynav"
          bg="warning"
          className="navbar navbar-expand-xl navbar-light bg-warning fs-5 text-dark fw-bold"
        >
          <Container className="d-sm-flex justify-content-center justify-content-between">
            <Navbar.Brand as={Link} className="mx-3" to="/">
              <div className="imgwrap_logo">
                <img className="w-100" src={Logo} alt="logo" />
              </div>
            </Navbar.Brand>
            {currentUser.kol_id.length > 0 && (
              <>
                <Navbar.Toggle
                  aria-controls="offcanvasNavbar-expand-xl"
                  onClick={offcanvasShow}
                />
                <Navbar.Offcanvas
                  show={show}
                  onHide={offcanvasClose}
                  id="offcanvasNavbar-expand-xl"
                  aria-labelledby="offcanvasNavbarLabel-expand-xl"
                  placement="end"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl">
                      {currentUser.displayName || currentUser.kol_name}
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav className=" flex-grow-1 pe-3 ">
                      <NavLink
                        to="/"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                        onClick={offcanvasClose}
                      >
                        綜合分析
                      </NavLink>
                      <NavLink
                        to="/fans"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                        onClick={offcanvasClose}
                      >
                        粉絲價值
                      </NavLink>
                      {/* <NavLink
                        to="/topic"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                        onClick={offcanvasClose}
                      >
                        話題成效
                      </NavLink> */}
                      {/* <NavLink
                        to="/issue"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                        onClick={offcanvasClose}
                      >
                        議題產生器
                      </NavLink> */}
                      {/* {isLevel2 && ( */}
                      <>
                        <NavLink
                          to="/satisfy"
                          className="item btn-warning nav-link"
                          activeclassname="active"
                          onClick={offcanvasClose}
                        >
                          即時滿意度
                        </NavLink>
                        {/* <NavLink
                          to="/computex"
                          className="item btn-warning nav-link"
                          activeclassname="active"
                          onClick={offcanvasClose}
                        >
                          COMPUTEX 露出
                        </NavLink> */}
                      </>
                      {/* )} */}

                      <hr />
                      {isLevel2 || (
                        <NavLink
                          to="/authorize"
                          className="item btn-warning nav-link d-xl-none"
                          activeclassname="active"
                          onClick={offcanvasClose}
                        >
                          社群平台帳號授權
                        </NavLink>
                      )}

                      <NavLink
                        to="/privacy"
                        className="item btn-warning nav-link d-xl-none"
                        activeclassname="active"
                        onClick={offcanvasClose}
                      >
                        隱私權政策
                      </NavLink>
                      <NavLink
                        to="/terms"
                        className="item btn-warning nav-link d-xl-none"
                        activeclassname="active"
                        onClick={offcanvasClose}
                      >
                        使用條款
                      </NavLink>
                      <Link
                        className="item btn-warning nav-link d-xl-none"
                        activeclassname="active"
                        onClick={() => {
                          Cookies.remove('tk')
                          handleLogout()
                          setCurrentUser({
                            inc_id: '',
                            tk: '',
                            kol_id: '',
                            kol_name: '',
                            lv: 1,
                            inc_name: '',
                            inc_icon: '',
                            isLocked: true,
                          })
                        }}
                        to="/"
                      >
                        登出
                      </Link>
                    </Nav>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
                <Navbar.Collapse id="navbarNav" className="">
                  <Nav className="mt-3 d-none">
                    <Nav.Item className="mt-auto">
                      <NavLink
                        // as={Link}
                        to="/"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                        // eventKey="/power"
                      >
                        綜合分析
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item className="mt-auto">
                      <NavLink
                        // as={Link}
                        to="/fans"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                      >
                        粉絲價值
                      </NavLink>
                    </Nav.Item>
                    {/* <Nav.Item className="mt-auto">
                      <NavLink
                        // as={Link}
                        to="/topic"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                      >
                        話題成效
                      </NavLink>
                    </Nav.Item> */}
                    {/* <Nav.Item className="mt-auto">
                      <NavLink
                        // as={Link}
                        to="/issue"
                        className="item btn-warning nav-link"
                        activeclassname="active"
                      >
                        議題產生器
                      </NavLink>
                    </Nav.Item> */}
                    {/* {isLevel2 && ( */}
                    <>
                      <Nav.Item className="mt-auto">
                        <NavLink
                          // as={Link}
                          to="/satisfy"
                          className="item btn-warning nav-link"
                          activeclassname="active"
                        >
                          即時滿意度
                        </NavLink>
                      </Nav.Item>
                      {/* <Nav.Item className="mt-auto">
                        <NavLink
                          // as={Link}
                          to="/computex"
                          className="item btn-warning nav-link"
                          activeclassname="active"
                        >
                          COMPUTEX 露出
                        </NavLink>
                      </Nav.Item> */}
                    </>
                    {/* )} */}
                  </Nav>
                  {/* --- 帳號 ---- */}
                  <div className="btn-group ms-auto d-none d-xl-block">
                    <button
                      type="button"
                      className="btn btn-warning dropdown-toggle fs-5 dropdown-padding"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {/* TODO:改帳號 */}
                      {currentUser.displayName || currentUser.kol_name}
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end">
                      {isLevel2 || (
                        <>
                          <li>
                            <Link className="dropdown-item" to="/authorize">
                              社群平台帳號授權
                            </Link>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                        </>
                      )}

                      <li>
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            handleLogout()
                            Cookies.remove('tk')
                            setCurrentUser({
                              inc_id: '',
                              tk: '',
                              kol_id: '',
                              kol_name: '',
                              lv: 1,
                              inc_name: '',
                              inc_icon: '',
                              isLocked: true,
                            })
                          }}
                          to="/"
                        >
                          登出
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Navbar.Collapse>
              </>
            )}
          </Container>
        </Navbar>
      </div>
    </>
  )
}

export default MyNav
